module.exports = __webpack_public_path__ + "img/Report.2eb80f51.svg";